import { render, staticRenderFns } from "./form-item-reference.vue?vue&type=template&id=30a30c06"
import script from "./form-item-reference.vue?vue&type=script&lang=js"
export * from "./form-item-reference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports